import React from 'react';
import PropTypes from 'prop-types';
import SubscribeInput from 'common/components/banner/subscribe-input';
import Button from 'common/components/atoms/button';
import BcsCloseIcon from 'bcs/icons/close';
import styles from 'styles/components/coupon/_coupon-content';

const SubscribeBody = (props) => {
  const {
    description,
    title,
    closeModal,
    onSubscribe,
    handleOpenDetails,
    couponAppliedSuccessfully,
    restrictions,
    onRedeem,
    isEmailSubs,
    buttons,
    error,
    image,
  } = props;

  return (
    <div className="subscription-modal__container">
      <button
        className="subscribe-modal__close-btn"
        role="button"
        onClick={closeModal}
      >
        <BcsCloseIcon />
      </button>
      <div className="subscription-modal__image-wrap">
        <img
          className="subscription-modal__image"
          alt=""
          src={image}
        />
      </div>
      <div className={`subscription-modal__content-wrap ${isEmailSubs ? '' : 'center-content-wrap'}`}>
        <div className="suscribe-modal__content">
          <h2 className="subscription-modal__title">{title}</h2>
          <span className="subscription-modal__description">
            <p id="coupon-banner-description" className={styles.description}>{description}</p>
          </span>
          {isEmailSubs ?
            <SubscribeInput
              onSubscribe={onSubscribe}
              error={error}
            /> :
            buttons.map(btn => (
              <div key={btn.url}>
                <Button
                  className="subscription-modal__suscribe-btn"
                  onClick={() => onRedeem(btn.url)}
                  primary
                >
                  {btn.title}
                </Button>
              </div>
            ))
          }
          {!couponAppliedSuccessfully && isEmailSubs && (
            <div className="subscription__exclusion-apply-txt">
              <span>
                {restrictions.description}
                <Button
                  className="subscription__terms-action"
                  onClick={handleOpenDetails}
                  reset
                >
                  {restrictions.cta}
                </Button>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

SubscribeBody.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  onSubscribe: PropTypes.func.isRequired,
  handleOpenDetails: PropTypes.func.isRequired,
  couponAppliedSuccessfully: PropTypes.bool,
  restrictions: PropTypes.object.isRequired,
  onRedeem: PropTypes.func.isRequired,
  isEmailSubs: PropTypes.bool.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  })),
};

export default SubscribeBody;
